import AdminOfflineDownloadsCount from "./AdminOfflineDownloadsCount";

export default AdminOfflineDownloadsCount;
